import { LitElement, html, defineElement  } from "@mds/core";
import { layoutCSS } from './layout.styles.js';
import { layoutResponsiveCSS } from './layout-responsive.styles.js';

/**
 * Layout Web Component
 * @slot - This element has a slot
 */
export class MdsLayout extends LitElement {

	static get styles()  {
		return [layoutCSS, layoutResponsiveCSS];
	}

	static get properties() {
		return {
			type: { type: String },
			zebra: { type: String },
			sidebar: { type: String },
			columns: { type: Number }
		};
	}
	constructor() {
		super();
		this.type = 'stacked';
		this.zebra = undefined;
		this.sidebar = undefined;
		this.columns = this.columns || 0;
	}
	render() {
		if (this.columns) {
			this.shadowRoot.host.setAttribute('style',`--column-count: ${this.columns}`);
		}
		return html`
			<slot name='navigation'></slot>
			<slot name='header'></slot>
			<slot name='main'></slot>
			<slot name='aside'></slot>
			<slot name='footer'></slot>
		`;
	}
}

defineElement("mds-layout", MdsLayout);
